import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const getDataFamilyMemberReport = async (values) => {
    const res = await axios.post(`${API_URL}family-member-report/data-statistics`, values);
    return res;
};

export const getFamilyMemberReportGraphical = async (values) => {
    const res = await axios.post(`${API_URL}family-member-report/graphical-statistics`, values);
    return res;
};
